$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX configurations
    require('./modules/ajax.js');

    // Service Worker
    // require('./modules/worker.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    // Datatable
    require('./modules/datatable.js');

    // Navigation Sidebar
    require('./modules/sidebar.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Phone Number Dropdown
    if ($('.input-phone:not(.ignore)').length > 0) {
        $('.input-phone:not(.ignore)').each((index, element) => {
            $(element).customPhoneInput();
        });
    }

    // Preloader
    $(window).on('load', function () {
        if (!window.forceLoader) {
            $(window).trigger('scroll');
            $('body').attr('data-loaded', true);
        }
    });

    setTimeout(() => {
        if (!window.forceLoader) {
            $('body').attr('data-loaded', true);
        }
    }, 1500);

    // Redirect to anchor
    if (!!window.location.hash.trim()) {
        var target = $('a[data-bs-target="' + window.location.hash + '"]');
        if (target.length > 0) {
            target.each((index, element) => {
                $(element).tab('show');
            })
        }
    }

    // Selection
    if ($('.selection:not(.ignore)').length > 0) {
        $('.selection:not(.ignore)').each((index, element) => {
            $(element).customSelection();
        });
    }

    // Prices Precision
    $(document).on('change', 'input[data-fixed]', function () {
        $(this).val($.parseNumber($(this).val()).toFixed($(this).data('fixed')));
    });

    // Event - User Logout
    $(document).on('click', '[data-event="logout"]', function (e) {
        $.ajax({
            type: 'POST',
            url: '/logout',
            success: function () {
                $.redirectTo('/portal');
            },
        });
    });
});
